/* Shopify theme asset: fiix-engaged-30s.js */
(() => {
  if (window.__fiixEngaged30s) return;
  window.__fiixEngaged30s = true;
  const KEY = 'fiix:engaged30s:v1';
  const EVENT = 'fiix:engaged_30s';
  let state = { ms: 0, fired: false };
  let restored = false;
  let last = performance.now();
  let wasVisible = document.visibilityState === 'visible';
  let wasAllowed = false;

  function allowed() {
    const p = window.Shopify?.customerPrivacy;
    return !!(p?.analyticsProcessingAllowed() &&
      p?.marketingAllowed() && p?.saleOfDataAllowed());
  }
  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {}
  }
  function tick() {
    const now = performance.now();
    // Do not count long gaps caused by suspension/device sleep.
    const delta = Math.max(0, Math.min(now - last, 1500));
    const consent = allowed();
    if (!consent) {
      if (restored) {
        try { sessionStorage.removeItem(KEY); } catch (_) {}
        state = { ms: 0, fired: false };
        restored = false;
      }
    } else {
      if (!restored) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
          if (saved && Number.isFinite(saved.ms) && saved.ms >= 0)
            state = { ms: saved.ms, fired: saved.fired === true };
        } catch (_) {}
        restored = true;
      }
      if (!state.fired && wasAllowed && wasVisible) state.ms += delta;
      if (!state.fired && state.ms > 30000 &&
          document.visibilityState === 'visible' &&
          typeof window.Shopify?.analytics?.publish === 'function') {
        try {
          window.Shopify.analytics.publish(EVENT, { threshold_seconds: 30 });
          state.fired = true;
        } catch (_) { /* Retry on the next tick if publishing throws. */ }
      }
      save();
    }
    last = now;
    wasVisible = document.visibilityState === 'visible';
    wasAllowed = consent;
  }
  function start() {
    tick();
    setInterval(tick, 1000);
    document.addEventListener('visibilitychange', tick);
    document.addEventListener('visitorConsentCollected', tick);
    window.addEventListener('pagehide', tick);
  }
  if (window.Shopify?.customerPrivacy) start();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
      error => { if (!error) start(); });
  }
})();
